var exports = {
  "h_": "DuplicateGroupConfirmModal.module__description___Q0F0eD",
  "o5": "DuplicateGroupConfirmModal.module__channelList___Q0F0eD",
  "fc": "DuplicateGroupConfirmModal.module__channelItem___Q0F0eD",
  "R3": "DuplicateGroupConfirmModal.module__avatarWrapper___Q0F0eD",
  "E8": "DuplicateGroupConfirmModal.module__channelDetails___Q0F0eD",
  "HA": "DuplicateGroupConfirmModal.module__channelName___Q0F0eD",
  "Rj": "DuplicateGroupConfirmModal.module__lastActive___Q0F0eD",
};

module.exports = exports;
